export default {
    user: null,
    token: null,
    loading: false,
    error: null,
    whatstext:null,
    currentForm: "form-doc-number",
    contacts: null,
    ownerId: null,   // resolvido no login; null enquanto não autenticado
}